<template>
    <div class="price">
        <span class="eshop">
            {{ eshopPriceText }}
        </span>
          <template v-if="defaultPrice && parseFloat(mainPrice) < parseFloat(defaultPrice)">
              <span class="old">{{ parseFloat(defaultPrice).toFixed(2) }} {{ currency }}</span>
          </template>
        <span class="main">
            {{ parseFloat(mainPrice).toFixed(2) }} {{ currency }}
        </span>

        <div class="stock">
            <template v-if="stockStatus >= 1">
                <p style="color: #10B981;">{{ onStockText }}</p>
            </template>
            <template v-else-if="parseInt(timeDeliveryStatus) === 5">
                <p style="color: #FF3C3C;">{{ unavailableText }}</p>
            </template>
            <template v-else>
                <p style="color: #FF3C3C;">{{ outStockText }}</p>
            </template>
        </div>

        <template v-if="defaultPrice && parseFloat(mainPrice) < parseFloat(defaultPrice)">
            <template v-if="priceHistory && JSON.parse(priceHistory) && parseFloat(JSON.parse(priceHistory).last_30_days_lowest) > 0">
                <small class="d-block" style="font-size: 10px;">Najnižšia cena za posledných 30 dní: {{ (parseFloat(JSON.parse(priceHistory).last_30_days_lowest)).toFixed(2) }} {{ currency }}</small>
            </template>
        </template>
    </div>
</template>

<script>
import {inject, onMounted, ref, toRefs} from 'vue'

export default {

    props: [
        'mainPriceP',
        'discountPriceP',
        'defaultPriceP',
        'stockP',
        'timeDeliveryP',
        'onStockText',
        'outStockText',
        'unavailableText',
        'eshopPriceText',
        'priceHistory'
    ],

    setup(props) {

        const mainPrice          = ref(props.mainPriceP)
        const discountPrice      = ref(props.discountPriceP)
        const defaultPrice       = ref(props.defaultPriceP)
        const stockStatus        = ref(props.stockP)
        const timeDeliveryStatus = ref(props.timeDeliveryP)

        const constants = inject('constants')
        const emitter  = inject('emitter')

        onMounted( () => {

            emitter.on('on-variation-set', ({ main_price, discount_price, default_price, stock, time_delivery }) => {
                mainPrice.value          = main_price
                discountPrice.value      = discount_price
                defaultPrice.value      = default_price
                stockStatus.value        = stock
                timeDeliveryStatus.value = time_delivery
            })

            console.log(defaultPrice)
            console.log(mainPrice)
        })

        return {
            ...toRefs(constants),
            mainPrice,
            discountPrice,
            defaultPrice,
            stockStatus,
            timeDeliveryStatus
        }
    }
}
</script>
